module.exports = __webpack_public_path__ + "img/reaction19.ce57a011.png";